import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from '../../components/auth/ProtectedRoute';


const ItemCategories = lazy(() => import('./ItemCategories'));
const StockList = lazy(() => import('./StockList'));
const StockTransfers = lazy(() => import('./StockTransfers'));
const StockAdjustments = lazy(() => import('./StockAdjustments'));
const Warehouses = lazy(() => import('./Warehouses'));
const WarehouseBins = lazy(() => import('./WarehouseBins'));
const ItemList = lazy(() => import('./ItemList'));
const CycleCounting = lazy(() => import('./CycleCounting'));
const Traceability = lazy(() => import('./Traceability'));
const GoodsReceiptNotes = lazy(() => import('../Procurement/GoodsReceiptNotes'));
const BatchManagement = lazy(() => import('./BatchManagement'));
const Picking = lazy(() => import('./Picking'));
const Units = lazy(() => import('./Units'));
const ShipmentList = lazy(() => import('./ShipmentList'));
const Brands = lazy(() => import('./Brands'));
const LandedCosts = lazy(() => import('./LandedCosts'));
const PackingOrders = lazy(() => import('./PackingOrders'));

export const inventoryRoutes = (
    <React.Fragment key="inventory">
        <Route element={<ProtectedRoute permission="inventory.item.view" />}>
            <Route path="/inventory/stock-list" element={<StockList />} />
            <Route path="/picking" element={<Picking />} />
            <Route path="/inventory/traceability" element={<Traceability />} />
            <Route path="/inventory/item-list" element={<ItemList />} />
        </Route>
        <Route element={<ProtectedRoute permission="inventory.stock_transfer.view" />}>
            <Route path="/inventory/stock-transfers" element={<StockTransfers />} />
            <Route path="/inventory/stock-transfer-notes" element={<StockTransfers />} />
        </Route>
        <Route element={<ProtectedRoute permission="inventory.stock_adjustment.view" />}>
            <Route path="/inventory/stock-adjustments" element={<StockAdjustments />} />
        </Route>
        <Route element={<ProtectedRoute permission="inventory.warehouse.view" />}>
            <Route path="/inventory/warehouses" element={<Warehouses />} />
        </Route>
        <Route element={<ProtectedRoute permission="inventory.bin.view" />}>
            <Route path="/inventory/warehouse-bins" element={<WarehouseBins />} />
        </Route>
        <Route element={<ProtectedRoute permission="inventory.cycle_count.view" />}>
            <Route path="/inventory/cycle-counting" element={<CycleCounting />} />
        </Route>
        <Route element={<ProtectedRoute permission="inventory.batch.view" />}>
            <Route path="/inventory/batches" element={<BatchManagement />} />
        </Route>
        <Route element={<ProtectedRoute permission="inventory.category.view" />}>
            <Route path="/item-categories" element={<ItemCategories />} />
        </Route>
        <Route element={<ProtectedRoute permission="inventory.unit.view" />}>
            <Route path="/inventory/units" element={<Units />} />
        </Route>
        <Route element={<ProtectedRoute permission="inventory.landed_cost.view" />}>
            <Route path="/inventory/landed-costs" element={<LandedCosts />} />
        </Route>
        <Route element={<ProtectedRoute permission="procurement.grn.view" />}>
            <Route path="/inventory/grns" element={<GoodsReceiptNotes />} />
        </Route>
        <Route element={<ProtectedRoute permission="inventory.brand.view" />}>
            <Route path="/inventory/brands" element={<Brands />} />
        </Route>
        <Route element={<ProtectedRoute permission="inventory.shipment.view" />}>
            <Route path="/inventory/shipments" element={<ShipmentList />} />
        </Route>
        <Route element={<ProtectedRoute permission="inventory.packing_order.view" />}>
            <Route path="/inventory/packing-orders" element={<PackingOrders />} />
        </Route>
    </React.Fragment>
);
